module.exports = __webpack_public_path__ + "img/KR.eac9e645.svg";